"use client";
import {
  VisuallyHidden
} from "./chunk-Q3P5COLX.js";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle
} from "./chunk-I57YZXPG.js";

// src/command.tsx
import { cn } from "@momo/utils";
import { Command as CommandPrimitive } from "cmdk";
import { jsx, jsxs } from "react/jsx-runtime";
var Command = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    CommandPrimitive,
    {
      className: cn(
        "bg-popover text-popover-foreground flex size-full flex-col overflow-hidden rounded-lg border py-2 shadow-md",
        "[&_[cmdk-group]:not([hidden])_~[cmdk-group]]:mt-2",
        className
      ),
      ...rest
    }
  );
};
var CommandDialog = (props) => {
  const { children, value, onValueChange, ...rest } = props;
  return /* @__PURE__ */ jsx(Dialog, { ...rest, children: /* @__PURE__ */ jsxs(DialogContent, { className: "overflow-hidden p-0 shadow-lg", children: [
    /* @__PURE__ */ jsxs(VisuallyHidden, { children: [
      /* @__PURE__ */ jsx(DialogTitle, { children: "Command Menu" }),
      /* @__PURE__ */ jsx(DialogDescription, { children: "Search a command" })
    ] }),
    /* @__PURE__ */ jsx(Command, { value, onValueChange, className: "border-0 shadow-none", children })
  ] }) });
};
var CommandInput = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: "mb-3 border-b pb-2", children: /* @__PURE__ */ jsx(
    CommandPrimitive.Input,
    {
      className: cn(
        "w-full bg-transparent px-4 py-2 text-sm outline-none",
        "placeholder:text-muted-foreground",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...rest
    }
  ) });
};
var CommandList = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    CommandPrimitive.List,
    {
      className: cn("max-h-[50vh] overflow-y-auto overflow-x-hidden px-2", className),
      ...rest
    }
  );
};
var CommandEmpty = (props) => {
  return /* @__PURE__ */ jsx(CommandPrimitive.Empty, { className: "py-6 text-center text-sm", ...props });
};
var CommandGroup = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    CommandPrimitive.Group,
    {
      className: cn(
        "text-foreground overflow-hidden",
        "[&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:text-xs",
        className
      ),
      ...rest
    }
  );
};
var CommandSeparator = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(CommandPrimitive.Separator, { className: cn("bg-border -mx-2 my-3 h-px", className), ...rest });
};
var CommandItem = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    CommandPrimitive.Item,
    {
      className: cn(
        "mt-1 flex h-10 cursor-default select-none items-center rounded-lg px-2 text-sm outline-none first:mt-2",
        "[&_svg]:pointer-events-none [&_svg]:mr-2 [&_svg]:size-3.5",
        "aria-[selected=true]:bg-accent",
        "data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50",
        "[&_kbd]:text-muted-foreground [&_kbd]:ml-auto [&_kbd]:text-xs",
        className
      ),
      ...rest
    }
  );
};
var CommandFooter = (props) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "mt-2 flex h-10 w-full items-center justify-between rounded-b-lg border-t px-2 pt-2",
      ...props
    }
  );
};
var CommandFooterTrigger = (props) => {
  const { triggerKey, children, className, ...rest } = props;
  return /* @__PURE__ */ jsxs("div", { className: cn("ml-auto flex items-center gap-2 text-xs", className), ...rest, children: [
    children,
    triggerKey
  ] });
};

export {
  Command,
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandSeparator,
  CommandItem,
  CommandFooter,
  CommandFooterTrigger
};
